import { useRef, useEffect } from "react";

export default function useScrollFadeIn(animation = "fade-in", delay = 0) {
  const ref = useRef();

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          node.classList.add(animation);
          node.style.animationDelay = `${delay}s`;
          observer.unobserve(node);
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [animation, delay]);

  return ref;
}